import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Stack, Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import Grid from '@mui/material/Grid2';
import 'moment/locale/th';
import moment from 'moment';
import {
    MDBListGroup, MDBListGroupItem, MDBBadge,
    MDBInput
    , MDBInputGroup
    , MDBRow, MDBCol
    , MDBIcon
    , MDBTextArea
    , MDBTimepicker
    , MDBDatepicker
    , MDBBtn
    , MDBSelect
    , MDBSelectOption
    , MDBAutocomplete
    , MDBCheckbox
}
    from 'mdb-react-ui-kit';
const Component = forwardRef((props, ref) => {
    const [overduechecked, setOverdueChecked] = useState(false);
    const [status, setStatus] = useState(0);
    const [monthFrom, setMonthFrom] = useState(null);
    const [dateFrom, setDateFrom] = useState(moment());
    const [dateTo, setDateTo] = useState(moment());
    const [customers, setCustomers] = useState(props.customers ?? []);
    const [selectCustomer, setSelectCustomer] = useState();

    const todaySearch = () => {
        setDateFrom(moment());
        setDateTo(moment());
        setMonthFrom(moment());
        search(moment(), moment());
    }
    const yesterdaySearch = () => {
        setDateFrom(moment().subtract(1, 'days'));
        setDateTo(moment().subtract(1, 'days'));
        setMonthFrom(moment().subtract(1, 'days'));
        search(moment().subtract(1, 'days'), moment().subtract(1, 'days'));
    }

    const thisMonthSearch = () => {
        var selectedmonth = moment().set({ date: '01' });
        setMonthRange(moment());
        search(moment(selectedmonth), moment(selectedmonth).add(1, 'months').subtract(1, 'days'));
    }
    const setMonthRange = (value) => {
        var selectedmonth = moment(value).set({ date: '01' });
        setDateFrom(moment(selectedmonth));

        setDateTo(moment(selectedmonth).add(1, 'months').subtract(1, 'days'));
        setMonthFrom(value);
    }
    const search = (dateFrom, dateTo) => {
        props.search?.apply(this, [dateFrom.format('YYYY-MM-DD'), dateTo.format('YYYY-MM-DD'), selectCustomer])
    }
    const search2 = (dateFrom, dateTo) => {
        props.search2?.apply(this, [selectCustomer])
    }

    const exportexcel = (dateFrom, dateTo) => {
        props.exportexcel?.apply(this, [dateFrom.format('YYYY-MM-DD'), dateTo.format('YYYY-MM-DD'), selectCustomer])
    }

    return (<>

        <LocalizationProvider dateAdapter={AdapterMoment} locale="th-TH">
            <Grid container spacing={2}
            >
                <Grid size={(props?.exportexcel ? 10 : 11)}>
             
                        <Stack className="search"
                            direction="row" spacing={2}
                            sx={{
                                alignItems: "baseline",
                            }}
                        >

                            {props.customers && <MDBSelect
                                search
                                data={customers}
                                displayValue={(row) => row.name}
                                label='เลือกลูกค้า'
                                value={selectCustomer}
                                onChange={(e) => {
                                    if (e.value === 0) {
                                        setSelectCustomer(0);

                                        return;
                                    }
                                    setSelectCustomer(e.value);

                                }}
                            />

                            }
                            {!props.customers && !props?.disablesearch && <><MDBInput
                               
                                label='ค้นหา'
                                value={selectCustomer}
                                onChange={(e) =>  {
                                    setSelectCustomer(e.target.value);
                                   
                                }}
                                onKeyDown={(event)=>{
                                     if (event.key === 'Enter')
                                    search(dateFrom, dateTo);
                                }}
                            /> <span>หรือ</span></>

                            }
                            <DatePicker
                                label="เลือกช่วงเดือน"
                                slotProps={{ textField: { size: 'small' } }}
                                views={['month', 'year']}
                                format="MMMM YYYY"
                                sx={{ maxWidth: 200 }}
                                value={monthFrom}
                                onChange={setMonthRange}
                            />


                            <span>หรือ</span>

                            <DatePicker
                                label="จาก"
                                value={dateFrom}
                                onChange={(newValue) => setDateFrom(newValue)}
                                slotProps={{ textField: { size: 'small' } }}
                                sx={{ maxWidth: 150 }}
                                format="DD/MM/YYYY"
                            />
                            <span>-</span>
                            <DatePicker
                                label="ถึง"
                                value={dateTo}
                                onChange={(newValue) => setDateTo(newValue)}
                                slotProps={{ textField: { size: 'small' } }}
                                sx={{ maxWidth: 150 }}
                                format="DD/MM/YYYY"
                            />
                            <span>หรือ</span>
                            <Button variant="outlined" size="large" onClick={todaySearch}>วันนี้</Button>
                            <Button variant="outlined" size="large" onClick={yesterdaySearch}>เมื่อวานนี้</Button>
                            <Button variant="outlined" size="large" onClick={thisMonthSearch}>เดือนนี้</Button>
                            {props.search2 && <Button variant="outlined" size="large" color="error" onClick={search2}>เกินกำหนดชำระ</Button>}
                        </Stack>

                 
                </Grid>
                <Grid size={1}

                    sx={{
                        justifyContent: "center",

                        alignItems: "flex-end",
                    }}>
                    <MDBBtn onClick={() => search(dateFrom, dateTo)} size="lg" rounded >ค้นหา  <MDBIcon className='ms-2' fas icon='search' /></MDBBtn>
                </Grid>

                {props?.exportexcel &&
                    <Grid size={1}

                        sx={{
                            justifyContent: "center",

                            alignItems: "flex-end",
                        }}>
                        <MDBBtn onClick={() => exportexcel(dateFrom, dateTo)} size="lg" rounded color="secondary" style={{ whiteSpace: "nowrap" }}>Export <MDBIcon className='ms-2' fas icon='file-export' /></MDBBtn>
                    </Grid>}
            </Grid>
        </LocalizationProvider>

    </>

    );
});



export default Component;